import { useMutation } from 'react-query';

import { uploadCardFile as mutationFn } from 'api/endPoints/uploadCardFile';

export const useMutationUploadBulkActions = () => {
    return useMutation<string, QueryError, IUploadBulkActions>((params) => mutationFn(params));
};

interface IUploadBulkActions {
    tags: string[];
    assignee: string | null;
    file: File;
    versionDbId: number;
}
